<template>
    <v-card class="show-packages-rate">
        <v-card-title>
            <span class="text-h5 mobile-text-f16">REVIEW RENTAL RATES</span>
        </v-card-title>
        <v-container class="p-4">
            <v-row class="mb-8">
                <v-col cols="12" md="10" class="align-item-center red--text h6" v-if="$store.state.resources.config.special_period_control == 1 && is_in_special_period">
                    <span v-if="special_period_rate_type == 'percent'">
                        Note: We have a special period from {{ special_period_start_date }} to {{ special_period_end_date }} and have {{ special_period_increase }}% increase rate on all packages.
                    </span>
                    <span v-else-if="special_period_rate_type === 'fixed'">
                        Note: We have a special period from {{ special_period_start_date }} to {{ special_period_end_date }} and have {{ _money(special_period_increase) }} increase rate on all packages.
                    </span>
                </v-col>
                <v-col cols="12" md="10" class="align-item-center">
                    This page lists all our prices, please click NEXT at the bottom of the page to actually select your package on the next page
                </v-col>
                <v-col cols="12" md="2" class="text-right">
                    <v-btn color="primary" @click="Next">Next</v-btn>
                </v-col>
            </v-row>
            <div class="mobile-block">
                <template v-for="package_categorie in packages">
                    <v-row class="border-bottom">
                        <v-col cols="12">
                            <h5 style="font-weight: bold">{{package_categorie.title}}</h5>
                        </v-col>
                    </v-row>
                    <template v-for="item in package_categorie.items">
                        <v-row class="package-border hovered-element">
                            <v-col cols="12">
                                <v-row class="border-bottom border-bottom">
                                    <v-col cols="12">
                                        <span class="text-primary">{{item.title}} <span v-if="(discount!==0  && discount_type=='percentage' && !$store.state.model.reservation.is_seasonal && $store.state.model.reservation._type!=='kiosk') && (config.module_type_enabled != 0 && config.module_type == 'module_13')">({{discount}}% Discount)</span></span>
                                    </v-col>
                                </v-row>
                                <template v-if="config.module_type_enabled != 0 && config.module_type == 'module_13'">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">Day 2 to 5 rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day2_5}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">Day 6+ rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_6_plus}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_9'">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">Day 2 to 3 rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day2_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">Day 4+ rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_4_plus}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal && $store.state.model.reservation._type=='kiosk'">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">1/2 Day rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.half_day_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">Night rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.night_rate}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_10'">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">Day 2 rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day2_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">Additional day rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.additional_day_rate}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_12'">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                        <template v-if="$store.state.model.reservation.single_day_type=='multiday' || $store.state.model.reservation._type=='kiosk'">
                                            <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                                <v-col cols="8">
                                                    <span class="mobile-text-f12">Day 2</span>
                                                </v-col>
                                                <v-col cols="4">
                                                    {{item.day_2_Rate}}
                                                </v-col>
                                            </v-row>
                                            <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                                <v-col cols="8">
                                                    <span class="mobile-text-f12">Day 3</span>
                                                </v-col>
                                                <v-col cols="4">
                                                    {{item.day_3_Rate}}
                                                </v-col>
                                            </v-row>
                                            <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                                <v-col cols="8">
                                                    <span class="mobile-text-f12">Day 4</span>
                                                </v-col>
                                                <v-col cols="4">
                                                    {{item.day_4_Rate}}
                                                </v-col>
                                            </v-row>
                                            <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                                <v-col cols="8">
                                                    <span class="mobile-text-f12">Day 5</span>
                                                </v-col>
                                                <v-col cols="4">
                                                    {{item.day_5_Rate}}
                                                </v-col>
                                            </v-row>
                                            <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                                <v-col cols="8">
                                                    <span class="mobile-text-f12">Additional</span>
                                                </v-col>
                                                <v-col cols="4">
                                                    {{item.additional_day_rate}}
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <template v-else>
                                            <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                                <v-col cols="8">
                                                    <span class="mobile-text-f12">Afternoon</span>
                                                </v-col>
                                                <v-col cols="4">
                                                    {{item.halfDayRate}}
                                                </v-col>
                                            </v-row>
                                            <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                                <v-col cols="8">
                                                    <span class="mobile-text-f12">Night</span>
                                                </v-col>
                                                <v-col cols="4">
                                                    {{item.nightRate}}
                                                </v-col>
                                            </v-row>
                                            <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                                <v-col cols="8">
                                                    <span class="mobile-text-f12">Morning</span>
                                                </v-col>
                                                <v-col cols="4">
                                                    {{item.morningRate}}
                                                </v-col>
                                            </v-row>
                                            <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                                <v-col cols="8">
                                                    <span class="mobile-text-f12">Twilight</span>
                                                </v-col>
                                                <v-col cols="4">
                                                    {{item.twilightRate}}
                                                </v-col>
                                            </v-row>
                                            <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                                <v-col cols="8">
                                                    <span class="mobile-text-f12">Beech Pass</span>
                                                </v-col>
                                                <v-col cols="4">
                                                    {{item.beechPassRate}}
                                                </v-col>
                                            </v-row>
                                        </template>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.skigd'">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <template v-if="$store.state.model.reservation.single_day_type=='afternoon'">
                                                <span class="mobile-text-f12">Afternoon</span>
                                            </template>
                                            <template v-else>
                                                <span class="mobile-text-f12">Night</span>
                                            </template>
                                        </v-col>
                                        <v-col cols="4">
                                            <template v-if="$store.state.model.reservation.single_day_type=='afternoon'">
                                                {{item.half_day_rate}}
                                            </template>
                                            <template v-else>
                                                {{item.night_rate}}
                                            </template>
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">{{multi_day_title}}</span>
                                        </v-col>
                                        <v-col cols="4">
                                            <template v-if="is_in_special_period && !$store.state.model.reservation.is_seasonal">
                                                ${{ getSpecialRate(item.multi_day_rate) }}
                                            </template>
                                            <template v-else>
                                                {{item.multi_day_rate}}
                                            </template>
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_17'">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                                <span class="mobile-text-f12">Night</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.night_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">{{multi_day_title}}</span>
                                        </v-col>
                                        <v-col cols="4">
                                            <template v-if="is_in_special_period && !$store.state.model.reservation.is_seasonal">
                                                ${{ getSpecialRate(item.multi_day_rate) }}
                                            </template>
                                            <template v-else>
                                                {{item.multi_day_rate}}
                                            </template>
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_16'">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">2 Day</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day2_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">3-4 Day</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day3_4_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">5+ Day</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_5_rate}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.nmsportsystems'">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">3 to 4 Day</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day3_4_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">5 to 6 Day</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day5_6_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">7+ Day</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_7_plus}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_14'">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>1 Day</span> </span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">2-3 Day</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day2_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">4+ Day</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_4_plus}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.gallatin' || frontend_view_folder == 'frontend.tygart' || (config.module_type_enabled != 0 && config.module_type == 'module_3')">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>1 Day</span> </span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">2-3 Day</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day3_4_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">4+ Day</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_4_plus}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.ridesnow'" >
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>Mid-Week Rate (M-TH) </span> </span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">Weekend / Holiday Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.holiday_rate}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_18'" >
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>Mid-Week Rate (M-F) </span> </span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">Weekend / Holiday Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.holiday_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">Night Skiing</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.night_rate}}
                                        </v-col>
                                    </v-row>

                                </template>
                                <template v-else-if="(config.module_type_enabled != 0 && config.module_type == 'module_6')" >
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>Mid-Week Rate (M-TH) </span> </span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">Weekend / Holiday Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.holiday_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">Night Skiing</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.night_rate}}
                                        </v-col>
                                    </v-row>

                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_11'">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>1st Day Rate</span> </span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">2nd Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_2_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">3rd Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_3_rate}}
                                        </v-col>
                                    </v-row>
                                     <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">3 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.additional_day_rate}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.plaines'">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>1st Day Rate</span> </span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">{{multi_day_title}}</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.multi_day_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">3rd Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_7_rate}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.mtshastasports'">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>1 Day Rate</span> </span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">2 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_2_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">3+ day Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_3_rate}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.basin' || (config.module_type_enabled != 0 && (config.module_type == 'module_5' || config.module_type == 'module_8'))">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>1 Day Rate</span> </span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">2 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_2_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">3 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_3_rate}}
                                        </v-col>
                                    </v-row>
                                     <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">4 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_4_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">5 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_5_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">6 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_6_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal && (config.module_type_enabled != 0 && config.module_type !== 'module_8') && showSevenDayRate">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">7 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_7_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal && frontend_view_folder == 'frontend.winterpark'">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">8 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_8_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal && frontend_view_folder == 'frontend.winterpark'">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">9 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_9_rate}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_5_2'">
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">1/2 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.half_day_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>1 Day Rate</span> </span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">2 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_2_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">3 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_3_rate}}
                                        </v-col>
                                    </v-row>
                                     <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">4 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_4_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">5 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_5_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">6 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_6_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal && (config.module_type_enabled != 0 && config.module_type !== 'module_8') && showSevenDayRate">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">7 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_7_rate}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_5_3'">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            <template v-if="is_in_special_period && !$store.state.model.reservation.is_seasonal">
                                                ${{ getSpecialRate(item.daily_rate) }}
                                            </template>
                                            <template v-else>
                                                {{item.daily_rate}}
                                            </template>
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">{{multi_day_title}}</span>
                                        </v-col>
                                        <v-col cols="4">
                                            <template v-if="is_in_special_period && !$store.state.model.reservation.is_seasonal">
                                                ${{ getSpecialRate(item.multi_day_rate) }}
                                            </template>
                                            <template v-else>
                                                {{item.multi_day_rate}}
                                            </template>
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal && $store.state.model.reservation._type!=='kiosk' && discount!==0  && discount_type=='percentage'">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">Advance Reservation <span v-if="discount!==0  && discount_type=='percentage'">({{discount}}% Discount)</span></span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">1/2 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.half_day_rate}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && (config.module_type == 'module_5_1')">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>1 Day Rate</span> </span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">2 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_2_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">3 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_3_rate}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.rootsrentals' || frontend_view_folder == 'frontend.stowe' || (config.module_type_enabled !=0 && config.module_type == 'module_4')">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>1 Day Rate</span> </span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">2 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_2_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">3 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_3_rate}}
                                        </v-col>
                                    </v-row>
                                     <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">4 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_4_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">5 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_5_rate}}
                                        </v-col>
                                    </v-row>

                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.pinnacle'">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal && multi_day_is_enabled">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">{{multi_day_title}}</span>
                                        </v-col>
                                        <v-col cols="4" >
                                            {{item.additional_day_rate}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="($store.state.model.reservation.single_day_type == 'day_hours' || $store.state.model.reservation.single_day_type == 'night_hours')">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            Weekends and Holiday
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.weekends_and_holiday}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            Week Days, Non Holiday
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.week_days_non_holiday}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            Night Hours
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.night_hours}}
                                        </v-col>
                                    </v-row>
                                </template>

                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_7'">

                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            <template v-if="$store.state.model.reservation._type=='kiosk' && !is_advance_seasonal">
                                                {{item.daily_rate}}
                                            </template>
                                            <template v-else>
                                                {{item.online_rate}}
                                            </template>
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">{{multi_day_title}}</span>
                                        </v-col>
                                        <v-col cols="4" v-if="!$store.state.model.reservation.is_seasonal">
                                            <template v-if="is_in_special_period && !$store.state.model.reservation.is_seasonal">
                                                ${{ getSpecialRate(item.multi_day_rate) }}
                                            </template>
                                            <template v-else>
                                                {{item.multi_day_rate}}
                                            </template>
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">7+ Days rates</span>
                                        </v-col>
                                        <v-col cols="4">
                                            <template v-if="is_in_special_period && !$store.state.model.reservation.is_seasonal">
                                                ${{ getSpecialRate(item.day_7_plus) }}
                                            </template>
                                            <template v-else>
                                                {{item.day_7_plus}}
                                            </template>
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_19'">
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">4 Day Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.day_4_rate}}
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">Weekly Rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.week_rate}}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else>
                                    <v-row class="border-bottom">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12"><span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate</span>
                                        </v-col>
                                        <v-col cols="4">
                                            <template v-if="is_in_special_period && !$store.state.model.reservation.is_seasonal">
                                                ${{ getSpecialRate(item.daily_rate) }}
                                            </template>
                                            <template v-else>
                                                {{item.daily_rate}}
                                            </template>
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">{{multi_day_title}}</span>
                                        </v-col>
                                        <v-col cols="4">
                                            <template v-if="is_in_special_period && !$store.state.model.reservation.is_seasonal">
                                                ${{ getSpecialRate(item.multi_day_rate) }}
                                            </template>
                                            <template v-else>
                                                {{item.multi_day_rate}}
                                            </template>
                                        </v-col>
                                    </v-row>
                                    <v-row class="border-bottom" v-if="!$store.state.model.reservation.is_seasonal && $store.state.model.reservation._type!=='kiosk' && discount!==0  && discount_type=='percentage'">
                                        <v-col cols="8">
                                            <span class="mobile-text-f12">Advance Reservation <span v-if="discount!==0  && discount_type=='percentage'">({{discount}}% Discount)</span></span>
                                        </v-col>
                                        <v-col cols="4">
                                            {{item.online_rate}}
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-col>
                        </v-row>
                    </template>
                </template>
            </div>
            <div class="desktop-block">
                <v-row class="bg-light border-bottom">
                    <v-col :cols="title_col" :md="title_col">
                        EQUIPMENT PACKAGE <span v-if="(discount!==0 && discount_type=='percentage' && !$store.state.model.reservation.is_seasonal && $store.state.model.reservation._type!=='kiosk') && (config.module_type_enabled != 0 && (config.module_type == 'module_9' || config.module_type == 'module_13'))">({{discount}}% Discount)</span>
                    </v-col>
                    <template v-if="$store.state.model.reservation.is_delivery">
                        <v-col :cols="daily_col" :md="daily_col" class="text-center">
                            Delivery rate
                        </v-col>
                    </template>
                    <template v-else>
                        <template v-if="config.module_type_enabled != 0 && config.module_type == 'module_13'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                <span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Day 2 to 5 rate
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Day 6+ rate
                            </v-col>
                        </template>
                        <template v-else-if="frontend_view_folder == 'frontend.skigd'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                <span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                <template v-if="$store.state.model.reservation.single_day_type=='afternoon'">
                                    <span class="mobile-text-f12">Afternoon</span>
                                </template>
                                <template v-else>
                                    <span class="mobile-text-f12">Night</span>
                                </template>
                            </v-col>
                            <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && multi_day_is_enabled">
                                {{multi_day_title}}
                            </v-col>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_17'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                <span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                    <span class="mobile-text-f12">Night</span>
                            </v-col>
                            <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && multi_day_is_enabled">
                                {{multi_day_title}}
                            </v-col>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_16'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                <span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>1 Day</span>
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                2 Day
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                3-4 Day
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                5+ Days
                            </v-col>
                        </template>
                        <template v-else-if="frontend_view_folder == 'frontend.nmsportsystems'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                <span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>1 Day</span>
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                3 to 4 Day
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                5 to 6 Day
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                7+ Days
                            </v-col>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_14'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                <span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>1 Day</span>
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                2-3 Days
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                4+ Days
                            </v-col>
                        </template>
                        <template v-else-if="frontend_view_folder == 'frontend.gallatin' || frontend_view_folder == 'frontend.tygart' || (config.module_type_enabled != 0 && config.module_type == 'module_3')">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                <span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>Day 1 to 2 rate</span>
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Day 3 to 4 rate
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Day 5 + rate
                            </v-col>
                        </template>
                        <template v-else-if="frontend_view_folder == 'frontend.ridesnow'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                {{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : 'Mid-Week Rate (M-TH)'}}
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Weekend / Holiday Rate
                            </v-col>
                        </template>
                        <template v-else-if="config.module_type_enabled !=0 && config.module_type == 'module_18'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                {{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : 'Mid-Week Rate (M-F)'}}
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Weekend / Holiday Rate
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                               Night Skiing
                            </v-col>
                        </template>
                        <template v-else-if="(config.module_type_enabled !=0 && config.module_type == 'module_6')">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                {{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : 'Mid-Week Rate (M-TH)'}}
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Weekend / Holiday Rate
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                               Night Skiing
                            </v-col>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_11'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                {{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1st Day Rate'}}
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                2nd Day Rate
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                3rd Day Rate
                           </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Additional Day Rate
                            </v-col>
                        </template>

                        <template v-else-if="frontend_view_folder == 'frontend.plaines'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                {{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : 'Daily rate '}}
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                {{multi_day_title}}
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Weekly rate
                           </v-col>
                        </template>

                        <template v-else-if="frontend_view_folder == 'frontend.mtshastasports'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                {{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 Day Rate'}}
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                2 Day Rate
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                3+ Day Rate
                           </v-col>
                        </template>
                        <template v-else-if="frontend_view_folder == 'frontend.basin' || (config.module_type_enabled != 0 && (config.module_type == 'module_5' || config.module_type == 'module_8'))">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                {{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 Day Rate'}}
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                2 Day Rate
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                3 Day Rate
                           </v-col>
                           <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                4 Day Rate
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                5 Day Rate
                           </v-col>
                           <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                6 Day Rate
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate">
                                7 Day Rate
                           </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate && frontend_view_folder == 'frontend.winterpark'">
                                8 Day Rate
                           </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate && frontend_view_folder == 'frontend.winterpark'">
                                9 Day Rate
                           </v-col>
                            <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && (config.module_type_enabled != 0 && config.module_type !== 'module_8')">
                                Additional Day Rate
                            </v-col>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_5_2'">
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                1/2 Day Rate
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                {{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 Day Rate'}}
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                2 Day Rate
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                3 Day Rate
                           </v-col>
                           <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                4 Day Rate
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                5 Day Rate
                           </v-col>
                           <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                6 Day Rate
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate">
                                7 Day Rate
                           </v-col>
                            <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && (config.module_type_enabled != 0 && config.module_type !== 'module_8')">
                                Additional Day Rate
                            </v-col>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_5_3'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" >
                                <span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate
                            </v-col>
                            <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && multi_day_is_enabled">
                                {{multi_day_title}}
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" v-if="discount!==0 && discount_type=='percentage' && $store.state.model.reservation._type!=='kiosk' && !$store.state.model.reservation.is_seasonal" class="text-center">
                                Advance Reservation <span v-if="discount!==0 && discount_type=='percentage'">({{discount}}% Discount)</span>
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                1/2 Day Rate
                            </v-col>
                        </template>
                        <template v-else-if="(config.module_type_enabled != 0 && config.module_type == 'module_5_1')">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                {{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 Day Rate'}}
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                2 Day Rate
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                3 Day Rate
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Additional Day Rate
                            </v-col>
                        </template>
                        <template v-else-if="frontend_view_folder == 'frontend.rootsrentals' || frontend_view_folder == 'frontend.stowe' || (config.module_type_enabled != 0 && config.module_type == 'module_4')">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                {{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 Day Rate'}}
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                2 Day Rate
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                3 Day Rate
                           </v-col>
                           <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                4 Day Rate
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                5 Day Rate
                           </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Additional Day Rate
                            </v-col>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_9'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                <span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Day 2 to 3 rate
                            </v-col>
                            <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Day 4+ rate
                            </v-col>
                            <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && $store.state.model.reservation._type=='kiosk' ">
                                1/2 Day rate
                            </v-col>
                            <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Night rate
                            </v-col>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_10'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                <span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Day 2 rate
                            </v-col>
                            <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Additional day rate
                            </v-col>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_12'">
                            <v-col cols="2" class="text-center">
                                <span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate
                            </v-col>
                            <template v-if="$store.state.model.reservation.single_day_type=='multiday' || $store.state.model.reservation._type=='kiosk'">
                                <v-col cols="1" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                    Day 2
                                </v-col>
                                <v-col cols="1" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                    Day 3
                                </v-col>
                                <v-col cols="1" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                    Day 4
                                </v-col>
                                <v-col cols="1" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                    Day 5
                                </v-col>
                                <v-col cols="2" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                    Additional
                                </v-col>
                            </template>
                            <template v-else>
                                <v-col cols="2" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                    Afternoon
                                </v-col>
                                <v-col cols="1" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                    Night
                                </v-col>
                                <v-col cols="1" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                    Morning
                                </v-col>
                                <v-col cols="1" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                    Twilight
                                </v-col>
                                <v-col cols="2" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                    Beech Pass
                                </v-col>
                            </template>
                        </template>
                        <template v-else-if="frontend_view_folder == 'frontend.pinnacle'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                <span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate
                            </v-col>
                            <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && multi_day_is_enabled">
                                {{multi_day_title}}
                            </v-col>
                        </template>
                        <template v-else-if="$store.state.model.reservation.single_day_type == 'day_hours' || $store.state.model.reservation.single_day_type == 'night_hours'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" >
                                Weekends and Holiday
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" class="text-center">
                                Week Days, Non Holiday
                            </v-col>
                            <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && multi_day_is_enabled">
                                Night Hours
                            </v-col>
                        </template>

                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_7'">

                            <v-col :cols="daily_col" :md="daily_col" class="text-center" >
                                <span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate
                            </v-col>
                            <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                {{multi_day_title}}
                            </v-col>
                            <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                7+ days rates
                            </v-col>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_19'">
                            <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                <span v-if="$store.state.model.reservation.is_seasonal">Seasonal rate</span><span v-else>Daily rate</span>
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                4 Day Rate
                            </v-col>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                Weekly Rate
                            </v-col>
                        </template>
                        <template v-else>
                            <v-col :cols="daily_col" :md="daily_col" class="text-center" >
                                <span v-if="$store.state.model.reservation.is_seasonal">Seasonal</span><span v-else>Daily</span> rate
                            </v-col>
                            <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && multi_day_is_enabled">
                                {{multi_day_title}}
                            </v-col>
                            <v-col :cols="online_col" :md="online_col" v-if="discount!==0 && discount_type=='percentage' && $store.state.model.reservation._type!=='kiosk' && !$store.state.model.reservation.is_seasonal" class="text-center">
                                Advance Reservation <span v-if="discount!==0 && discount_type=='percentage'">({{discount}}% Discount)</span>
                            </v-col>
                        </template>
                    </template>
                </v-row>
                <template v-for="package_categorie in packages">
                    <v-row class="border-bottom">
                        <v-col cols="12">
                            <h5 style="font-weight: bold">{{package_categorie.title}}</h5>
                        </v-col>
                    </v-row>
                    <template v-for="item in package_categorie.items">
                        <v-row class="border-bottom hovered-element">
                            <v-col :cols="title_col" :md="title_col">
                                <v-tooltip bottom v-if="item.description!==null">
                                    <template v-slot:activator="{ on, attrs }">
                                    <span class="text-light-blue"
                                          v-bind="attrs"
                                          v-on="on"
                                    >
                                       {{item.title}}
                                    </span>
                                    </template>
                                    <span v-html="item.description"></span>
                                </v-tooltip>
                                <span v-else>
                                {{item.title}}
                            </span>
                            </v-col>
                            <template v-if="$store.state.model.reservation.is_delivery">
                                <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                    {{item.current_rate}}
                                </v-col>
                            </template>
                            <template v-else>
                                <template v-if="config.module_type_enabled != 0 && config.module_type == 'module_13'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.online_rate}}
                                    </v-col>
                                    <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day2_5}}
                                    </v-col>
                                    <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_6_plus}}
                                    </v-col>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.skigd'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.online_rate}}
                                    </v-col>
                                    <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        <template v-if="$store.state.model.reservation.single_day_type=='afternoon'">
                                            {{item.half_day_rate}}
                                        </template>
                                        <template v-else>
                                            {{item.night_rate}}
                                        </template>
                                    </v-col>
                                    <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && multi_day_is_enabled">
                                        <template v-if="is_in_special_period && !$store.state.model.reservation.is_seasonal">
                                            ${{ getSpecialRate(item.multi_day_rate) }}
                                        </template>
                                        <template v-else>
                                            {{item.multi_day_rate}}
                                        </template>
                                    </v-col>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_16'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.current_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day2_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day3_4_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_5_rate}}
                                    </v-col>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.nmsportsystems'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.current_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day3_4_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day5_6_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_7_plus}}
                                    </v-col>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_14'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.current_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day2_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_4_plus}}
                                    </v-col>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.gallatin' || frontend_view_folder == 'frontend.tygart' || (config.module_type_enabled != 0 && config.module_type == 'module_3')">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.current_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day3_4_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_4_plus}}
                                    </v-col>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.ridesnow'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.current_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.holiday_rate}}
                                    </v-col>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && (config.module_type == 'module_6' || config.module_type == 'module_18')">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.current_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.holiday_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.night_rate}}
                                    </v-col>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_11'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.current_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_2_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_3_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.additional_day_rate}}
                                    </v-col>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.plaines'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.current_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.multi_day_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_7_rate}}
                                    </v-col>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.mtshastasports'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.current_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_2_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_3_rate}}
                                    </v-col>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.basin' || (config.module_type_enabled != 0 && (config.module_type == 'module_5' || config.module_type == 'module_8'))">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">

                                        {{item.current_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_2_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_3_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_4_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_5_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_6_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate">
                                        {{item.day_7_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate && frontend_view_folder == 'frontend.winterpark'">
                                        {{item.day_8_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate && frontend_view_folder == 'frontend.winterpark'">
                                        {{item.day_9_rate}}
                                    </v-col>
                                    <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && (config.module_type_enabled != 0 && config.module_type !== 'module_8')">
                                        {{item.additional_day_rate}}
                                    </v-col>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_5_2'">
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.half_day_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.current_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_2_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_3_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_4_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_5_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_6_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate">
                                        {{item.day_7_rate}}
                                    </v-col>
                                    <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && (config.module_type_enabled != 0 && config.module_type !== 'module_8')">
                                        {{item.additional_day_rate}}
                                    </v-col>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_5_3'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        <template v-if="is_in_special_period && !$store.state.model.reservation.is_seasonal">
                                            ${{ getSpecialRate(item.daily_rate) }}
                                        </template>
                                        <template v-else>
                                            {{item.daily_rate}}
                                        </template>
                                    </v-col>
                                    <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && multi_day_is_enabled">
                                        <template v-if="is_in_special_period && !$store.state.model.reservation.is_seasonal">
                                            ${{ getSpecialRate(item.multi_day_rate) }}
                                        </template>
                                        <template v-else>
                                            {{item.multi_day_rate}}
                                        </template>
                                    </v-col>
                                    <v-col :cols="online_col" :md="online_col" v-if="discount!==0 && discount_type=='percentage' && $store.state.model.reservation._type!=='kiosk' && !$store.state.model.reservation.is_seasonal" class="text-center">
                                        {{item.online_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.half_day_rate}}
                                    </v-col>
                                </template>
                                <template v-else-if="(config.module_type_enabled != 0 && config.module_type == 'module_5_1')">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.current_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_2_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_3_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.additional_day_rate}}
                                    </v-col>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.rootsrentals' || frontend_view_folder == 'frontend.stowe' || (config.module_type_enabled != 0 && config.module_type == 'module_4')">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.current_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_2_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_3_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_4_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_5_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.additional_day_rate}}
                                    </v-col>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_17'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.online_rate}}
                                    </v-col>
                                    <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.night_rate}}
                                    </v-col>
                                    <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && multi_day_is_enabled">
                                        <template v-if="is_in_special_period && !$store.state.model.reservation.is_seasonal">
                                            ${{ getSpecialRate(item.multi_day_rate) }}
                                        </template>
                                        <template v-else>
                                            {{item.multi_day_rate}}
                                        </template>
                                    </v-col>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_9'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.online_rate}}
                                    </v-col>
                                    <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day2_rate}}
                                    </v-col>
                                    <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_4_plus}}
                                    </v-col>
                                    <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && $store.state.model.reservation._type=='kiosk'">
                                        {{item.half_day_rate}}
                                    </v-col>
                                    <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.night_rate}}
                                    </v-col>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_10'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.online_rate}}
                                    </v-col>
                                    <v-col :cols="online_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day2_rate}}
                                    </v-col>
                                    <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.additional_day_rate}}
                                    </v-col>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_12'">
                                    <v-col cols="2" class="text-center">
                                        {{item.online_rate}}
                                    </v-col>
                                    <template v-if="$store.state.model.reservation.single_day_type=='multiday' || $store.state.model.reservation._type=='kiosk'">
                                        <v-col cols="1" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                            {{item.day_2_Rate}}
                                        </v-col>
                                        <v-col cols="1" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                            {{item.day_3_Rate}}
                                        </v-col>
                                        <v-col cols="1" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                            {{item.day_4_Rate}}
                                        </v-col>
                                        <v-col cols="1" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                            {{item.day_5_Rate}}
                                        </v-col>
                                        <v-col cols="2" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                            {{item.additional_day_rate}}
                                        </v-col>
                                    </template>
                                    <template v-else>
                                        <v-col cols="2" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                            {{item.halfDayRate}}
                                        </v-col>
                                        <v-col cols="1" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                            {{item.nightRate}}
                                        </v-col>
                                        <v-col cols="1" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                            {{item.morningRate}}
                                        </v-col>
                                        <v-col cols="1" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                            {{item.twilightRate}}
                                        </v-col>
                                        <v-col cols="2" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                            {{item.beechPassRate}}
                                        </v-col>
                                    </template>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.pinnacle'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.online_rate}}
                                    </v-col>
                                    <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && multi_day_is_enabled">
                                        {{item.additional_day_rate}}
                                    </v-col>
                                </template>
                                <template v-else-if="$store.state.model.reservation.single_day_type == 'day_hours' || $store.state.model.reservation.single_day_type == 'night_hours'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.weekends_and_holiday}}
                                    </v-col>
                                    <v-col :cols="online_col" :md="online_col" class="text-center">
                                        {{item.week_days_non_holiday}}
                                    </v-col>
                                    <v-col :cols="multi_col" :md="multi_col" class="text-center">
                                        {{item.night_hours}}
                                    </v-col>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_7'">

                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        <template v-if="$store.state.model.reservation._type=='kiosk' && !is_advance_seasonal">
                                            {{item.daily_rate}}
                                        </template>
                                        <template v-else>
                                            {{item.online_rate}}
                                        </template>
                                    </v-col>
                                    <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        <template v-if="is_in_special_period && !$store.state.model.reservation.is_seasonal">
                                            ${{ getSpecialRate(item.multi_day_rate) }}
                                        </template>
                                        <template v-else>
                                            {{item.multi_day_rate}}
                                        </template>
                                    </v-col>
                                    <v-col :cols="online_col" :md="online_col"  v-if="!$store.state.model.reservation.is_seasonal" class="text-center">
                                        {{item.day_7_plus}}
                                    </v-col>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_19'">
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        {{item.current_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.day_4_rate}}
                                    </v-col>
                                    <v-col :cols="daily_col" :md="online_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal">
                                        {{item.week_rate}}
                                    </v-col>
                                </template>
                                <template v-else>
                                    <v-col :cols="daily_col" :md="daily_col" class="text-center">
                                        <template v-if="is_in_special_period && !$store.state.model.reservation.is_seasonal">
                                            ${{ getSpecialRate(item.daily_rate) }}
                                        </template>
                                        <template v-else>
                                            {{item.daily_rate}}
                                        </template>
                                    </v-col>
                                    <v-col :cols="multi_col" :md="multi_col" class="text-center" v-if="!$store.state.model.reservation.is_seasonal && multi_day_is_enabled">
                                        <template v-if="is_in_special_period && !$store.state.model.reservation.is_seasonal">
                                            ${{ getSpecialRate(item.multi_day_rate) }}
                                        </template>
                                        <template v-else>
                                            {{item.multi_day_rate}}
                                        </template>
                                    </v-col>
                                    <v-col :cols="online_col" :md="online_col" v-if="discount!==0 && discount_type=='percentage' && $store.state.model.reservation._type!=='kiosk' && !$store.state.model.reservation.is_seasonal" class="text-center">
                                        {{item.online_rate}}
                                    </v-col>
                                </template>
                            </template>
                        </v-row>
                    </template>
                </template>
            </div>
            <v-row class="mt-8 mb-3 justify-content-end">
                <v-col cols="12" md="2" class="text-right">
                    <v-btn color="primary" @click="Next">Next</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import moment from "moment";
import step_2 from "../../reservations/advance/validation/step_2";
import {formatMoney} from "../../plugins/utils";

export default {
    name: "DialogShowPackagesRate",
    data      : () => ({
        title_col: 4,
        daily_col: 2,
        online_col: 3,
        multi_col: 3
    }),
    computed  : {
        ...mapGetters(['packages_list_data', 'is_in_special_period', 'special_period_increase', 'special_period_start_date', 'special_period_end_date', 'special_period_rate_type']),
        packages() {
            let selectItems = []
            this.packages_list_data.forEach(g => {
                g.items = g.items.filter((item) => {
                    let current_rate = "0";
                    if(item.hasOwnProperty('current_rate')){
                        current_rate = item.current_rate.replace('$', '');
                    }
                    return parseInt(current_rate)!==0;
                })
                if(g.items.length !== 0){
                    selectItems.push(g);
                }
            });
            return selectItems;
        },
        discount() {
            return parseInt(this.$store.state.resources.config.discount);
        },
        discount_type() {
            return this.$store.state.resources.config.discount_type;
        },
        frontend_view_folder() {
            return this.$store.state.resources.config.frontend_view_folder;
        },
        multi_day_is_enabled() {
            return parseInt(this.$store.state.resources.config.multi_day_is_enabled);
        },
        multi_day_title() {
            return (parseInt(this.$store.state.resources.config.multi_day_start_after) + 1) + " and more days Rate";
        },
        config(){
            return this.$store.state.resources.config;
        },
        is_advance_seasonal() {
            return window.location.href.includes('seasonal');
        },
        showSevenDayRate() {
            return window.location.hostname !== 'rentals.alpenhausonline.com';
          }
    },
    methods   : {
        ...mapMutations(['reservee_save']),
        async Next() {
            this.$store.commit('set_is_watched_rental_details', true);
            this.$emit('modal-close');
        },
        getSpecialRate(baseRate) {
            const rate = parseFloat(baseRate.replace('$',''));
            
            if (this.special_period_rate_type === 'percent') {
                return (rate + (rate * this.special_period_increase) / 100).toFixed(2);
            }

            if (this.special_period_rate_type === 'fixed') {
                return (rate + this.special_period_increase).toFixed(2);
            }

            return rate.toFixed(2);
        },
        _money(val){
            return formatMoney(val);
        },
    },
    mounted() {
        if((this.$store.state.model.reservation._type=='advance' && (((this.discount==0 && this.discount_type=='percentage') || (this.discount_type!=='percentage')) || !this.multi_day_is_enabled)) || (this.$store.state.model.reservation._type=='kiosk' && (this.$store.state.model.reservation.single_day_type !== "day_hours" && this.$store.state.model.reservation.single_day_type !== "night_hours"))){
            this.title_col = 7;
        }
        if((this.$store.state.model.reservation._type=='advance' && (((this.discount==0 && this.discount_type=='percentage') || (this.discount_type!=='percentage')) && !this.multi_day_is_enabled)) || (this.$store.state.model.reservation._type=='kiosk' && !this.multi_day_is_enabled && (this.$store.state.model.reservation.single_day_type !== "day_hours" && this.$store.state.model.reservation.single_day_type !== "night_hours"))){
            this.title_col = 10;
        }
        if(this.$store.state.resources.config.frontend_view_folder=='frontend.skigd'){
            if(this.multi_day_is_enabled){
                this.title_col = 4;
            }else{
                this.title_col = 7;
            }
        }
        if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_12'){
            if(this.$store.state.model.reservation.single_day_type=='multiday' || this.$store.state.model.reservation._type=='kiosk'){
                this.title_col = 4;
            }else{
                this.title_col = 3;
            }
        }
        if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_16'){
            this.title_col = 3;
            this.daily_col = 2;
            this.online_col = 2;
            this.multi_col = 2;
        }
        if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_17'){
            this.title_col = 6;
            this.daily_col = 2;
            this.online_col = 2;
            this.multi_col = 2;
        }
        if(this.$store.state.resources.config.frontend_view_folder=='frontend.nmsportsystems'){
            this.title_col = 3;
            this.daily_col = 2;
            this.online_col = 2;
            this.multi_col = 2;
        }
        if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_14'){
            this.title_col = 6;
            this.daily_col = 2;
            this.online_col = 2;
            this.multi_col = 2;
        }
        if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_11'){
            this.title_col = 3;
            this.daily_col = 2;
            this.online_col = 2;
            this.multi_col = 2;
        }
        if(this.$store.state.resources.config.frontend_view_folder=='frontend.plaines'){
            this.title_col = 4;
            this.daily_col = 2;
            this.online_col = 2;
            this.multi_col = 2;
        }
        if(this.$store.state.resources.config.frontend_view_folder=='frontend.mtshastasports'){
            this.title_col = 5;
            this.daily_col = 2;
            this.online_col = 2;
            this.multi_col = 2;
        }
        if(this.$store.state.resources.config.frontend_view_folder=='frontend.basin' || (this.$store.state.resources.config.module_type_enabled != 0 && (this.$store.state.resources.config.module_type == 'module_5' || this.$store.state.resources.config.module_type == 'module_8'))){
            if(this.$store.state.resources.config.frontend_view_folder=='frontend.winterpark'){
                this.title_col = 2;
            } else {
                this.title_col = 3;
            }
            this.daily_col = 1;
            this.online_col = 1;
            this.multi_col = 1;
            if(this.$store.state.resources.config.module_type == 'module_8'){
                this.daily_col = 2;
            }
            if(!this.showSevenDayRate){
                this.title_col = 4;
                this.multi_col = 2;
            }
        }
        if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_5_1'){
            this.title_col = 3;
            this.daily_col = 2;
            this.online_col = 2;
        }
        if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_5_2'){
            this.title_col = 3;
            this.daily_col = 1;
            this.online_col = 1;
            this.multi_col = 1;
        }
        if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_5_3'){
            this.title_col = 3;
            this.daily_col = 2;
            this.online_col = 2;
            this.multi_col = 2;
            if(this.$store.state.model.reservation.is_from_kiosk == 1){
                this.daily_col = 3;
                this.multi_col = 3;
            }
        }
        if(this.$store.state.resources.config.frontend_view_folder=='frontend.rootsrentals' || this.$store.state.resources.config.frontend_view_folder=='frontend.stowe' || (this.$store.state.resources.config.module_type_enabled !=0 && this.$store.state.resources.config.module_type == 'module_4')){
            this.title_col = 5;
            this.daily_col = 1;
            this.online_col = 1;
            this.multi_col = 1;
        }
        if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_13'){
            this.title_col = 6;
            this.daily_col = 2;
            this.online_col = 2;
            this.multi_col = 2;
        }
        if(this.$store.state.resources.config.frontend_view_folder=='frontend.gallatin' || this.$store.state.resources.config.frontend_view_folder=='frontend.tygart' || (this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_3')){
            this.title_col = 6;
            this.daily_col = 2;
            this.online_col = 2;
            this.multi_col = 2;
        }
        if(this.$store.state.resources.config.frontend_view_folder=='frontend.ridesnow'){
            this.title_col = 6 ;
            this.daily_col = 3;
            this.online_col = 3;
            this.multi_col = 3;
        }
        if(this.$store.state.resources.config.module_type_enabled != 0 && (this.$store.state.resources.config.module_type == 'module_6' || this.$store.state.resources.config.module_type == 'module_18')){
            this.title_col = 5;
            this.daily_col = 2;
            this.online_col = 2;
            this.multi_col = 2;
        }

        if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_7'){

            this.title_col = 6;
            this.daily_col = 2;
            this.online_col = 2;
            this.multi_col = 2;
        }
        if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_10'){

            this.title_col = 6;
            this.daily_col = 2;
            this.online_col = 2;
            this.multi_col = 2;
        }
        if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_9'){

            this.title_col = 4;
            this.daily_col = 2;
            this.online_col = 2;
            this.multi_col = 2;
            if(this.$store.state.model.reservation._type =='kiosk'){
                this.title_col = 3;
                this.online_col = 1;
            }
        }
        if(this.$store.state.model.reservation.is_seasonal || this.$store.state.model.reservation._type =='kiosk'){
            if(!this.$store.state.model.reservation.is_seasonal && this.multi_day_is_enabled){
                this.title_col = 6;
            } else {
                this.title_col = 9;
            }
            this.daily_col = 3;
        }
        if(this.$store.state.model.reservation.is_delivery){
            this.title_col = 9;
        }
        if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_19'){
            this.title_col = 3;
            this.daily_col = 3;
        }
    }
}
</script>
<style>
.show-packages-rate .col-6, .show-packages-rate .col-8{
    padding-right: 5px;
    padding-left: 5px;
}
</style>
<style scoped>
.hovered-element:hover div{
    background-color: #f5f5f5;
}
.package-border{
    border-bottom: 1px solid #3490dc;
}

@media (max-width: 575.98px) {
    .mobile-text-f16{
        font-size: 16px !important;
    }
    .mobile-text-f12{
        font-size: 12px !important;
    }
    .desktop-block{
        display: none;
    }
    .mobile-block{
        display: block;
    }
}

@media (min-width: 576px){
    .mobile-block{
        display: none;
    }
    .desktop-block{
        display: block;
    }
}
</style>
